import { useMutation } from '@tanstack/react-query';

import { type components, createLegalParty } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

type CreateLegalPartyValues = Omit<
  components['schemas']['CompanyCreateCmd'],
  'documents' | 'claims' | 'links' | 'risk_objects' | 'type'
>;

export default function useCreateLegalParty() {
  return useMutation({
    mutationFn: (values: CreateLegalPartyValues) =>
      createLegalParty(
        {
          body: {
            ...values,
            type: 'COMPANY',
            documents: [],
            claims: [],
            links: [],
            risk_objects: {
              cars: [],
              residences: [],
              families: [],
              two_wheelers: [],
              teachers: [],
              legal: [],
              party_groups: [],
              boats: [],
              miscellanea: [],
              trailers: [],
              semi_trailers: [],
              fleets: [],
              bicycles: [],
            },
          },
        },
        wgApi,
      ),
  });
}
